import IconTextColumn, { cellType, iconTextColumnConfiguration } from './IconTextColumn.component';

export { cellType, IconTextColumn };
export default iconTextColumnConfiguration;
